import axios from 'axios'

const API_PATH = 'admins/finance/bank_transactions/bulk'

const BankTransactionsBulkApi = {
  /**
   * Update Bulk ::Finance::BankTransaction record
   * Invoke `PATCH admins/finance/bank_transactions/bulk`
   * @param {Array} financeBankTransactionIds - array of ::Finance::BankTransaction ids
   * @param {Object} tl_bank - array of ::TlBank ids
   * @param {String} category - bank transaction category
   * @param {String} cash_flow - bank transaction cash flow
   */
  update: async ({
    financeBankTransactionIds,
    tl_bank,
    category,
    cash_flow
  }) => {
    const body = {
      finance_bank_transaction_ids : financeBankTransactionIds,
      tl_bank_id                   : tl_bank.id,
      category                     : category,
      cash_flow                    : cash_flow
    }

    const response = await axios.post(API_PATH, body)
    return response
  },
  /**
   * Delete multiple ::Finance::BankTransaction record
   * Invoke `DELETE admins/finance/bank_transactions/bulk`
   * @param {Array} financeBankTransactionIds - array of ::Finance::BankTransaction ids
   */
  delete: async ({
    financeBankTransactionIds
  }) => {
    const payload = {
      finance_bank_transaction_ids: financeBankTransactionIds
    }

    const response = await axios.delete(API_PATH, { data: payload })
    return response
  },
  /**
   * Download sales reconcile csv for certain date range
   * Invoke `get /admins/finance/bank_transactions/bulk/csv`
   * @param {String} bankTransactionDateFrom - Sales reconcile start date, Finance::BankTransaction.created_at
   * @param {String} bankTransactionDateTo - Sales reconcile end date, Finance::BankTransaction.created_at
   */
  generateSalesReconcileCsv: async ({ bankTransactionDateFrom, bankTransactionDateTo }) => {
    const params   = {
      bank_transaction_date_from : bankTransactionDateFrom,
      bank_transaction_date_to   : bankTransactionDateTo
    }
    const path     = `${API_PATH}/csv`
    const response = await axios.get(path, { params })
    return response
  }
}

export default BankTransactionsBulkApi
